__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "operations";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.11.4", () => (Promise.all([__webpack_require__.e(894), __webpack_require__.e(914), __webpack_require__.e(326)]).then(() => (() => (__webpack_require__(90326))))));
			register("@emotion/styled", "11.11.0", () => (Promise.all([__webpack_require__.e(914), __webpack_require__.e(371), __webpack_require__.e(903)]).then(() => (() => (__webpack_require__(45903))))));
			register("@mui/material", "5.15.14", () => (Promise.all([__webpack_require__.e(894), __webpack_require__.e(513), __webpack_require__.e(871), __webpack_require__.e(722), __webpack_require__.e(455), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(371), __webpack_require__.e(118), __webpack_require__.e(413)]).then(() => (() => (__webpack_require__(49722))))));
			register("@mui/system", "5.15.14", () => (Promise.all([__webpack_require__.e(894), __webpack_require__.e(513), __webpack_require__.e(871), __webpack_require__.e(844), __webpack_require__.e(914), __webpack_require__.e(371), __webpack_require__.e(118)]).then(() => (() => (__webpack_require__(28844))))));
			register("@reduxjs/toolkit", "1.9.7", () => (Promise.all([__webpack_require__.e(621), __webpack_require__.e(137)]).then(() => (() => (__webpack_require__(92621))))));
			register("axios", "0.26.1", () => (__webpack_require__.e(854).then(() => (() => (__webpack_require__(40854))))));
			register("i18next", "23.10.1", () => (__webpack_require__.e(978).then(() => (() => (__webpack_require__(44978))))));
			register("jwt-decode", "3.1.2", () => (__webpack_require__.e(70).then(() => (() => (__webpack_require__(87070))))));
			register("moment", "2.30.1", () => (__webpack_require__.e(178).then(() => (() => (__webpack_require__(86178))))));
			register("oidc-client", "1.11.5", () => (__webpack_require__.e(958).then(() => (() => (__webpack_require__(66958))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(97950))))));
			register("react-i18next", "14.1.0", () => (Promise.all([__webpack_require__.e(117), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(74117))))));
			register("react-redux", "7.2.9", () => (Promise.all([__webpack_require__.e(508), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(716)]).then(() => (() => (__webpack_require__(97508))))));
			register("react-router-dom", "6.22.3", () => (Promise.all([__webpack_require__.e(245), __webpack_require__.e(914), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(53245))))));
			register("react", "18.2.0", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(65043))))));
			register("redux", "4.2.1", () => (__webpack_require__.e(634).then(() => (() => (__webpack_require__(50634))))));
			initExternal(93672);
			initExternal(15679);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};